module.exports = __webpack_public_path__ + "static/media/car-cardinal-care-svgrepo-com.e83c6085.svg";